import { render, staticRenderFns } from "./layout-cabinet.vue?vue&type=template&id=a0ffa3bc"
import script from "./layout-cabinet.vue?vue&type=script&lang=js"
export * from "./layout-cabinet.vue?vue&type=script&lang=js"
import style0 from "./layout-cabinet.vue?vue&type=style&index=0&id=a0ffa3bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports